import React from 'react';
import { useAuth } from '@/contexts/hooks/useAuth';

interface AdminContentWrapperProps {
  children: React.ReactNode;
}

const AdminContentWrapper: React.FC<AdminContentWrapperProps> = ({ children }) => {
  const { isAdmin, user } = useAuth();

  // Debug logging
  if (user) {
    console.log('Current user role:', user.role);
    console.log('Is admin?', isAdmin);
  }

  return (
    <>
      <div>
        {children}
      </div>
    </>
  );
};

export default AdminContentWrapper;